import React, { useEffect, useState } from 'react';
import {
    Box, Paper, Typography, Button, CircularProgress, Alert, Tabs, Tab,
    Breadcrumbs, Link as MuiLink, ThemeProvider,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import MarkdownRender from '../../components/Markdown';
import rdnsTheme from './rdnsTheme';

// Ajuda do DNS Reverso. O markdown vem do backend (docs/rdns/guia.md e
// docs/nodes/provisionamento-ssh.md) — o mesmo arquivo que o time usa no
// repo, então não tem doc duplicada saindo de sincronia.
const DOCS = [
    { key: 'guia', label: 'Como usar', title: 'Como usar o DNS Reverso' },
    { key: 'servidores', label: 'Preparar um servidor', title: 'Preparando um servidor DNS' },
]

export default function RDNSDocs() {
    const navigate = useNavigate()
    const [params, setParams] = useSearchParams()
    const initial = Math.max(0, DOCS.findIndex(d => d.key === params.get('doc')))
    const [tab, setTab] = useState(initial)
    const [text, setText] = useState('')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const doc = DOCS[tab]

    useEffect(() => { document.title = `IPV7 Tools - ${doc.title}` }, [doc])

    useEffect(() => {
        setLoading(true); setError(null); setText('')
        api.get(`/dns/rdns/docs/${doc.key}`)
            .then(res => setText(typeof res.data === 'string' ? res.data : ''))
            .catch(e => setError(e.response?.status === 404
                ? 'Documento não encontrado no servidor.'
                : (e.response?.data?.detail || e.message)))
            .finally(() => setLoading(false))
    }, [doc.key])

    const change = (e, v) => { setTab(v); setParams({ doc: DOCS[v].key }) }

    return (
        <ThemeProvider theme={rdnsTheme}>
            <Box sx={{ p: 2, maxWidth: 980, mx: 'auto' }}>
                <Breadcrumbs sx={{ mb: 1 }}>
                    <MuiLink component="button" underline="hover" color="inherit" onClick={() => navigate('/dns_rdns')}>
                        DNS Reverso (RDNS)
                    </MuiLink>
                    <Typography color="text.primary">Ajuda</Typography>
                </Breadcrumbs>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="h5">Ajuda — DNS Reverso</Typography>
                    <Button size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate('/dns_rdns')}>Voltar</Button>
                </Box>

                <Tabs value={tab} onChange={change} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    {DOCS.map(d => <Tab key={d.key} label={d.label} />)}
                </Tabs>

                <Paper sx={{ p: 3 }}>
                    {loading && <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>}
                    {error && <Alert severity="error">{error}</Alert>}
                    {!loading && !error && <MarkdownRender text={text} />}
                </Paper>
            </Box>
        </ThemeProvider>
    )
}
